import StickyNoteForm from "../components/stickynoteform";
import ScrollBox from "../components/scrollbox";
import StickyNote from "../components/stickynote";
import TagGrid from "../components/taggrid";
import '../styles/home.css';
import React, { useState, useEffect } from 'react';

const Home = () => {
    const [darkMode, setDarkMode] = useState(false);
    const [showJobTitle, setShowJobTitle] = useState(false);
    const techTags = [
        { text: "Python", image: "/img/pythonicon.png" },
        { text: "C Programming", image: "/img/cIcon.png" },
        { text: "Javascript", image: "/img/jsIcon.png" },
        { text: "Figma", image: "/img/figmaIcon.png" },
        { text: "Django", image: "/img/djangoIcon.png" },
        { text: "React", image: "/img/reactIcon.png" },
        { text: "Flask", image: "/img/flaskIcon.png" },
        { text: "Typescript", image: "/img/tsIcon.png" },
        { text: "FastAPI", image: "/img/fastapiIcon.png" },
        { text: "Docker", image: "/img/dkIcon.png" },
        { text: "Bash Scripting", image: "/img/bashIcon.png" },
        { text: "Css", image: "/img/csIcon.png" },
        { text: "Html", image: "/img/htIcon.png" },
        { text: "SQL", image: "/img/sqlIcon.png"},
        { text: "MongoDB", image: "/img/mongodbIcon.png"},
    ]

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };

    useEffect(() => {
        const timer = setTimeout(() => setShowJobTitle(true), 500);
        return () => clearTimeout(timer); // Cleanup
    }, []);
   
    return (
        <div className="home-container">
            <a href="/aboutme"><img className="profile-img" src='/img/me.png' alt="Me"/></a>

            <span className="introduction">
               Hello <span role="img" aria-label="waving hand">👋🏽</span>, I'm <br />
               <strong className="myname">Merit Edafe </strong>
            </span>

            <div className={`jobtitle ${showJobTitle ? 'show' : ''}`}>
                Software Engineer
                <p>
                <p>I am a full stack software engineer with a passion for building
                robust, user-focused applications.</p>
                <p>Experienced in both backend and frontend technologies,</p>
                I enjoy solving complex problems and creating solutions that make a real impact.
               </p>

                <div className="socialmediaicons">
                <a href="https://www.linkedin.com/in/edafemerit/" target="_blank" rel="noopener noreferrer">
                    <img style={{ width: '20px', height: '20px' }} src="./img/linkedin.png" alt="linkedin" />
                </a>
                <a href="https://www.github.com/merytpeters" target="_blank" rel="noopener noreferrer">
                    <img style={{ width: '20px', height: '20px' }} src="./img/github.png" alt="github" />
                </a>
                <a href="mailto:merytpeters@gmail.com" target="_blank" rel="noopener noreferrer">
                <img style={{ width: '20px', height: '20px' }} src="./img/gmailicon.png" alt="gmail" />
                </a>
            </div>
           </div>
           <div className="introNote-div">
            <StickyNote 
            title="Welcome 👋🏽 to my Portfolio"
            message="I'm a Full Stack Developer by day, an anatomist by degree, and a digital health tech wizard 24/7. I build products that keep both codebases and heart rates stable—because debugging and diagnostics have more in common than you'd think! 🚀💻🩺"
            color="#B0C4DE"/>
            </div>
            <div className="moretalk">
                <StickyNote
                title="What I Love Doing"
                message="I love building innovative digital health solutions that bridge the gap between healthcare and technology.
                My passion lies in developing full-stack applications, optimizing interoperability, and enhancing user experiences in the digital health space."
                color="#A07856"
                />
            </div>

           <div className={`home ${darkMode ? 'dark-mode' : 'light-mode'}`}>
            <button onClick={toggleDarkMode}>
                {darkMode ? 'Light' : 'Dark'}
            </button>

            {/*<img className="myphoto" src='./img/myphoto.png' alt='mine'/>*/}

            <div className="scrollbar-div">
            <ScrollBox children={
            <div id="projects">
                <div className="Telemed"> <a href="/telemedicine" >Digital Health Apps</a></div>
                <div className="fun-projects"> <a href="/funprojects" >Fun Projects</a></div>
                <div className="serverApi"> <a href="/serverApi">Server APIs</a></div>
                <div className="casestud"><a href="/casestudies">Case Studies</a></div>
                <div className="resume"><a href="/resume">Resume </a></div>
                <div className="Inter"><a href="#projects">Interoperability Projects</a></div>
                <div className="dataanal"><a href="#projects" >Data Engineering & Dashboards</a></div> 
            </div>
            } />
            </div>

            <div className="techstack-container">
                <div className="techstack-scroll">
                    <div className="scrolling-text">
                        Tech-Stack, Frameworks and Tools  * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢ Tech-Stack, Frameworks and Tools * ⇢
                    </div>
                    <div>
                        <TagGrid tags={techTags} />
                    </div>
                 </div>
            </div>

            <StickyNoteForm emailLabel="Email" messageLabel="Message" buttonText="Submit"/>
            
           </div>
        </div>
    );
};

export default Home;